export const getPackage = (packageId) => ({ packages }) =>
  packages.packageList.find(({ id }) => id === packageId);
